import React from "react"
import { Box } from "@infotech/uikit-grid"
import { CompareIcon } from "@infotech/uikit-icons"
import StatusesList from "./List"
import styles from "./styles.css"

const EventTypeStatusModel = ({
  isNew,
  id,
  statusModelPermission,
  resourceTypeList,
}) => (
  <Box loose className={styles.StatusWrapper}>
    {isNew ? (
      <Box loose className={styles.NewWrapper} flex column>
        <Box loose pl="130px">
          <CompareIcon
            size="large"
            color="#edf2f7"
            className={styles.LargeIcon}
          />
        </Box>
        <Box loose pt="2md" className={styles.NewStatusHeader}>
          Статусная модель не создана
        </Box>
        <Box loose pt="2md" className={styles.NewStatusText}>
          После создания типа события будет доступна возможность задать
          статусную модель
        </Box>
      </Box>
    ) : (
      <StatusesList
        id={id}
        statusModelPermission={statusModelPermission}
        resourceTypeList={resourceTypeList}
      />
    )}
  </Box>
)

export default EventTypeStatusModel
